/**
 * Created by rorschach on 2018/5/25.
 */
import React from "react";
import {
  Route
  // Redirect
} from "react-router-dom";
// import utils from "../utils/utils";
// import weixinJsSdk from "../utils/weixinJsSdk";

function createCustomRouteRender(route) {
  return function(props) {
    // 未登录 跳转到登录页
    // route.loginRequired
    // 强制所有页面都要先登录
    // if(props.location.pathname==="/rank"){
    //   return <route.component {...props} routes={route.routes} />;
    // }
    // if (route.loginRequired && !utils.isAtLoginPage() && !utils.isLogin()) {
    //   // utils.redirectToLogin(utils.getCurrentPageUrl(), false);
    //   // return null;
    //   return <Redirect push={false} to={utils.getLoginUrl()} />;
    // }
    // if (!utils.isLogin()) {

    //   return <Redirect push={false} to={utils.getLoginUrl()} />;
    // }

    console.log(
      props.location.pathname +
        "_" +
        props.location.search +
        "_" +
        props.location.url
    );
    // 每次路由切换, 都尝试去初始化微信jssdk
    // weixinJsSdk.ready();

    // 渲染原始组件
    // 支持routes=[]嵌套路由
    // pass the sub-routes down to keep nesting
    return <route.component {...props} routes={route.routes} />;
  };
}

const CustomRoute = route => {
  const { component, ...rest } = route;

  return <Route {...rest} render={createCustomRouteRender(route)} />;
};

export default CustomRoute;



// WEBPACK FOOTER //
// ./src/router/CustomRoute.js